@if (rubriken) {
  @for (rubrik of rubriken; track rubrik) {
    <cap-grundstueck-rubriken [grundstueck]="grundstueckEntry" [item]="rubrik">
      {{ rubrik }}
    </cap-grundstueck-rubriken>
  }
}
